import { Navigate, useRoutes } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
import Login from "./pages/Login";
import DashboardApp from "./pages/DashboardApp";
// import NotFound from "./pages/Page404"; // 暂时未使用
// 配置
import PrivateRoute from "./components/PrivateRoute";
import UserList from "./pages/user/UserList";
import UserDetail from "./pages/user/UserDetail";
import MyInfo from "./pages/MyInfo";
import ArticleList from "./pages/article/ArticleList";
import ArticleCategory from "./pages/article/ArticleCategory";
import BusinessSchoolCategory from "./pages/businessSchool/BusinessSchoolCategory";
import BusinessSchoolList from "./pages/businessSchool/BusinessSchoolList";
import MerchantCodeList from "./pages/businessSchool/MerchantCodeList";
import CompanyEventIndex from "./pages/companyEvent/index";
import CompanyEventActivity from "./pages/companyEvent/activity";
import ArticleDetail from "./pages/article/ArticleDetail";
import BusinessSchoolDetail from "./pages/businessSchool/BusinessSchoolDetail";
import Images from "./pages/resource/Images";

import ProductList from "./pages/store/ProductList";
import ProductDetail from "./pages/store/ProductDetail";
import MerchantCategory from "./pages/merchant/MerchantCategory";
import MerchantList from "./pages/merchant/MerchantList";
import MerchantKflist from "./pages/merchant/MerchantKflist";
import MerchantApplyList from "./pages/merchant/MerchantApplyList";
import MerchantType from "./pages/merchant/MerchantType";
import { ROLE } from "./config/constants";
import BalanceRecord from "./pages/finance/BalanceRecord";
import ProductAttr from "./pages/store/ProductAttr";
import ProductCategory from "./pages/store/ProductCategory";
import PayList from "./pages/finance/payList";

// 商户
import MerchantMenu from "./pages/merchant/MerchantMenu";
import MenuList from "./pages/diy/MenuList";
import BannerList from "./pages/diy/BannerList";

import SystemMenu from "./pages/system/access/SystemMenu";
import SystemRole from "./pages/system/access/SystemRole";
import SystemAdmin from "./pages/system/access/SystemAdmin";
import SystemmAnage from "./pages/system/manage/SystemmAnage";
import { MerchantOrderList as OrderList } from "./pages/store/OrderList";
import SystemConfigList from "./pages/dev/SystemConfigList";
import AgentConfig from "./pages/agent/AgentConfig";
import AgentList from "./pages/agent/AgentList";
import AgentDetail from "./pages/agent/AgentDetail";
import PointConfig from "./pages/point/PointConfig";
import PointRecord from "./pages/point/PointRecord";
import WithdrawRecord from "./pages/finance/WithdrawRecord";
import NoticeList from "./pages/setting/NoticeList";
import DiyList from "./pages/diy/DiyList";
import DiyDetail from "./pages/diy/DiyDetail";
import OrderStats from "./pages/order/OrderStats";
import ProductBaodan from "./pages/store/ProductBaodan";
import UserAuth from "./pages/user/UserAuth";
import KefuConfig from "./pages/kefu/KefuConfig";
import KefuChat from "./pages/kefu/KefuChat";
import SharesRecord from "./pages/finance/SharesRecord";
import PaymentList from "./pages/order/PaymentList";
import StoreTransaction from "./pages/store/StoreTransaction";
import MerchantDetail from "./pages/merchant/MerchantDetail";
import StaffList from "./pages/user/StaffList";
import Orgs from "./pages/user/Orgs";
import MerchantRank from "./pages/stats/MerchantRank";
import StoreZiti from "./pages/store/StoreZiti";
import AgentMenu from "./pages/agent/AgentMenu";
import MerchantActivity from "./pages/merchant/MerchantActivity";
import StatsArea from "./pages/stats/StatsArea";
import TiejunList from "./pages/user/TiejunList";
import TiejunRank from "./pages/stats/TiejunRank";
import CouponList from "./pages/coupon/CouponList";
import CouponDetail from "./pages/coupon/CouponDetail";
import CouponRecord from "./pages/coupon/CouponRecord";
import TiejunMonthList from "./pages/user/TiejunMonthList";
import BalanceStats from "./pages/finance/BalanceStats";
import TiejunApplyList from "./pages/user/TiejunApplyList";
import VisitRecord from "./pages/user/VisitRecord";
import StatsPreview from "./pages/finance/StatsPreview";
import TransactionList from "./pages/finance/TransactionList";
import HexiaoList from "./pages/coupon/HexiaoList";
import AgentBalanceRecord from "./pages/finance/AgentBalanceRecord";
import MerchantSpeaker from "./pages/merchant/MerchantSpeaker";
import ProductSection from "./pages/store/ProductSection";
import ProductBrand from "./pages/store/ProductBrand";
import StoreSupplier from "./pages/store/StoreSupplier";
import XfqRecord from "./pages/finance/XfqRecord";
import DhqRecord from "./pages/finance/DhqRecord";
import EquityValueRecord from "./pages/finance/EquityValueRecord";
import FreeBenefitRecord from "./pages/finance/FreeBenefitRecord";
import ContributionPriceHistory from "./pages/finance/ContributionPriceHistory";
import PaymentDiscountRecord from "./pages/finance/PaymentDiscountRecord";
import ShareholderList from "./pages/shareholder/ShareholderList";
import AgreementList from "./pages/setting/AgreementList";
import DownloadList from "./pages/task/DownloadList";
import ShareholderConfig from "./pages/shareholder/ShareholderConfig";
import UserParentDetail from "./pages/user/UserParentDetail";
import TxqRecord from "./pages/finance/TxqRecord";
import ProductZy from "./pages/store/ProductZy";
import SupplierDashboardApp from "./pages-supplier/SupplierDashboardApp";
import SupplierProductList from "./pages-supplier/product/SupplierProductList";
import SupplierProductAttr from "./pages-supplier/product/SupplierProductAttr";
import SupplierOrderList from "./pages-supplier/order/SupplierOrderList";
import SupplierTransaction from "./pages-supplier/finance/SupplierTransaction";
import SupplierSettlement from "./pages-supplier/finance/SupplierSettlement";
import SupplierInfo from "./pages-supplier/SupplierInfo";
import SupplierRole from "./pages-supplier/access/SupplierRole";
import SupplierAdmin from "./pages-supplier/access/SupplierAdmin";
import SupplierMenu from "./pages/supplier/SupplierMenu";
import SupplierList from "./pages/supplier/SupplierList";
import HuifuAccounts from "./pages/finance/HuifuAccounts";
import XfqV2Bak0302 from "./pages/finance/XfqV2Bak0302";
import AuctionApiLog from "./pages/jingxi/AuctionApiLog";
import JytUserList from "./pages/jingxi/JytUserList";
import DragonBeadLog from "./pages/jingxi/DragonBeadLog";
import DhzTransferLog from "./pages/jingxi/DhzTransferLog";
import JytAdminOperationLogList from "./pages/jingxi/JytAdminOperationLogList";
import JytVipList from "./pages/jingxi/JytVipList";
import JytVipLog from "./pages/jingxi/JytVipLog";
import SessionConfigList from "./pages/jingxi/SessionConfigList";
import GradeList from "./pages/jingxi/GradeList";
import SessionList from "./pages/jingxi/SessionList";
import JytOrderList from "./pages/jingxi/OrderList";
import RobotList from "./pages/jingxi/RobotList";
import DispatchCenter from "./pages/jingxi/DispatchCenter";
import ReleaseControl from "./pages/jingxi/ReleaseControl";
import ReleaseOverview from "./pages/jingxi/ReleaseOverview";
import PaymentConfig from "./pages/jingxi/PaymentConfig";
import DirectValueRatioConfig from "./pages/jingxi/DirectValueRatioConfig";
import RoleAllowanceConfig from "./pages/jingxi/RoleAllowanceConfig";
import FlashSaleSessionList from "./pages/flash-sale/SessionList";
// import ComingSoon from "./pages/jingxi/ComingSoon"; // 暂时未使用
import AdminOperationLogList from "./pages/system/AdminOperationLogList";

let routes = [
  {
    path: "",
    exact: true,
    element: <PrivateRoute element={<DashboardApp />} />,
  },
  { path: "user/list", element: <PrivateRoute element={<UserList />} /> },
  {
    path: "user/edit/:uid",
    element: <PrivateRoute element={<UserDetail />} />,
  },
  { path: "user/auth", element: <PrivateRoute element={<UserAuth />} /> },
  {
    path: "user/staff/list",
    element: <PrivateRoute element={<StaffList />} />,
  },
  {
    path: "user/tiejun/list",
    element: <PrivateRoute element={<TiejunList />} />,
  },
  {
    path: "user/tiejun/upgrade",
    element: <PrivateRoute element={<TiejunMonthList />} />,
  },
  { path: "user/orgs", element: <PrivateRoute element={<Orgs />} /> },
  {
    path: "user/tiejun/apply",
    element: <PrivateRoute element={<TiejunApplyList />} />,
  },
  {
    path: "user/visit/list",
    element: <PrivateRoute element={<VisitRecord />} />,
  },
  {
    path: "user/parent/detail/:uid",
    element: <PrivateRoute element={<UserParentDetail />} />,
  },

  // 商户
  {
    path: "merchant/category",
    element: <PrivateRoute element={<MerchantCategory />} />,
  },
  {
    path: "merchant/list",
    element: <PrivateRoute element={<MerchantList />} />,
  },
  {
    path: "merchant/kflist",
    element: <PrivateRoute element={<MerchantKflist />} />,
  },
  {
    path: "merchant/apply",
    element: <PrivateRoute element={<MerchantApplyList />} />,
  },
  {
    path: "merchant/type",
    element: <PrivateRoute element={<MerchantType />} />,
  },
  {
    path: "merchant/menu",
    element: <PrivateRoute element={<MerchantMenu />} />,
  },
  {
    path: "merchant/add",
    element: <PrivateRoute element={<MerchantDetail />} />,
  },
  {
    path: "merchant/edit/:mid",
    element: <PrivateRoute element={<MerchantDetail />} />,
  },
  {
    path: "merchant/activity",
    element: <PrivateRoute element={<MerchantActivity />} />,
  },
  {
    path: "merchant/speaker/list",
    element: <PrivateRoute element={<MerchantSpeaker />} />,
  },

  // 商品
  { path: "product/list", element: <PrivateRoute element={<ProductList />} /> },
  {
    path: "product/baodan",
    element: <PrivateRoute element={<ProductBaodan />} />,
  },
  {
    path: "product/add",
    element: <PrivateRoute element={<ProductDetail />} />,
  },
  {
    path: "product/edit/:id",
    element: <PrivateRoute element={<ProductDetail />} />,
  },
  { path: "product/attr", element: <PrivateRoute element={<ProductAttr />} /> },
  {
    path: "product/category",
    element: <PrivateRoute element={<ProductCategory />} />,
  },
  {
    path: "store/transaction/list",
    element: <PrivateRoute element={<StoreTransaction />} />,
  },
  {
    path: "store/ziti/list",
    element: <PrivateRoute element={<StoreZiti />} />,
  },
  {
    path: "product/section/list",
    element: <PrivateRoute element={<ProductSection />} />,
  },
  { path: "product/zy", element: <PrivateRoute element={<ProductZy />} /> },
  {
    path: "product/brand/list",
    element: <PrivateRoute element={<ProductBrand />} />,
  },
  {
    path: "store/supplier/list",
    element: <PrivateRoute element={<StoreSupplier />} />,
  },

  // 订单
  { path: "order/stats", element: <PrivateRoute element={<OrderStats />} /> },
  { path: "order/list", element: <PrivateRoute element={<OrderList />} /> },
  {
    path: "order/payment",
    element: <PrivateRoute element={<PaymentList />} />,
  },
  {
    path: "companyEvent/index",
    element: <PrivateRoute element={<CompanyEventIndex />} />,
  },
  {
    path: "companyEvent/activity",
    element: <PrivateRoute element={<CompanyEventActivity />} />,
  },

  // 积分
  { path: "point/config", element: <PrivateRoute element={<PointConfig />} /> },
  { path: "point/record", element: <PrivateRoute element={<PointRecord />} /> },

  // 财务
  {
    path: "finance/balance/list",
    element: <PrivateRoute element={<BalanceRecord />} />,
  },
  {
    path: "finance/xfq/list",
    element: <PrivateRoute element={<XfqRecord />} />,
  },
  {
    path: "finance/txq/list",
    element: <PrivateRoute element={<TxqRecord />} />,
  },
  {
    path: "finance/dhq/list",
    element: <PrivateRoute element={<DhqRecord />} />,
  },
  {
    path: "finance/withdraw",
    element: <PrivateRoute element={<WithdrawRecord />} />,
  },
  {
    path: "finance/share/list",
    element: <PrivateRoute element={<SharesRecord />} />,
  },
  {
    path: "finance/point/list",
    element: <PrivateRoute element={<PointRecord />} />,
  },
  {
    path: "finance/balance/stats",
    element: <PrivateRoute element={<BalanceStats />} />,
  },
  {
    path: "finance/stats/preview",
    element: <PrivateRoute element={<StatsPreview />} />,
  },
  {
    path: "finance/accounts",
    element: <PrivateRoute element={<HuifuAccounts />} />,
  },
  {
    path: "finance/transaction/list",
    element: <PrivateRoute element={<TransactionList />} />,
  },
  { path: "finance/pay/list", element: <PrivateRoute element={<PayList />} /> },
  {
    path: "finance/xfq-v2-bak0302",
    element: <PrivateRoute element={<XfqV2Bak0302 />} />,
  },
  {
    path: "finance/payment-discount/record",
    element: <PrivateRoute element={<PaymentDiscountRecord />} />,
  },
  {
    path: "finance/equity-value/list",
    element: <PrivateRoute element={<EquityValueRecord />} />,
  },
  {
    path: "finance/free-benefit/list",
    element: <PrivateRoute element={<FreeBenefitRecord />} />,
  },
  {
    path: "finance/contribution-price-history",
    element: <PrivateRoute element={<ContributionPriceHistory />} />,
  },

  // 金银通乐园
  {
    path: "jingxi/jyt-user/list",
    element: <PrivateRoute element={<JytUserList />} />,
  },
  {
    path: "jingxi/dragon-bead-log",
    element: <PrivateRoute element={<DragonBeadLog />} />,
  },
  {
    path: "jingxi/dhz-transfer-log",
    element: <PrivateRoute element={<DhzTransferLog />} />,
  },
  {
    path: "jingxi/auction-api-log",
    element: <PrivateRoute element={<AuctionApiLog />} />,
  },
  {
    path: "jingxi/jyt-admin-operation-log",
    element: <PrivateRoute element={<JytAdminOperationLogList />} />,
  },
  {
    path: "jingxi/jyt-vip/list",
    element: <PrivateRoute element={<JytVipList />} />,
  },
  {
    path: "jingxi/jyt-vip/log",
    element: <PrivateRoute element={<JytVipLog />} />,
  },
  {
    path: "jingxi/session-config",
    element: <PrivateRoute element={<SessionConfigList />} />,
  },
  {
    path: "jingxi/grade",
    element: <PrivateRoute element={<GradeList />} />,
  },
  {
    path: "jingxi/game/sessions",
    element: <PrivateRoute element={<SessionList />} />,
  },
  {
    path: "jingxi/game/orders",
    element: <PrivateRoute element={<JytOrderList />} />,
  },
  {
    path: "jingxi/game/robots",
    element: <PrivateRoute element={<RobotList />} />,
  },
  {
    path: "jingxi/game/dispatch",
    element: <PrivateRoute element={<DispatchCenter />} />,
  },
  {
    path: "jingxi/release-control",
    element: <PrivateRoute element={<ReleaseControl />} />,
  },
  {
    path: "jingxi/release-overview",
    element: <PrivateRoute element={<ReleaseOverview />} />,
  },
  {
    path: "jingxi/payment-config",
    element: <PrivateRoute element={<PaymentConfig />} />,
  },
  {
    path: "jingxi/direct-value-ratio-config",
    element: <PrivateRoute element={<DirectValueRatioConfig />} />,
  },
  {
    path: "jingxi/role-allowance-config",
    element: <PrivateRoute element={<RoleAllowanceConfig />} />,
  },
  {
    path: "flash-sale/sessions",
    element: <PrivateRoute element={<FlashSaleSessionList />} />,
  },

  {
    path: "system/admin-operation-log",
    element: <PrivateRoute element={<AdminOperationLogList />} />,
  },

  // 联创
  {
    path: "shareholder/list",
    element: <PrivateRoute element={<ShareholderList />} />,
  },
  {
    path: "shareholder/config",
    element: <PrivateRoute element={<ShareholderConfig />} />,
  },
  {
    path: "task/download/list",
    element: <PrivateRoute element={<DownloadList />} />,
  },

  // 供应商
  {
    path: "supplier/menu/list",
    element: <PrivateRoute element={<SupplierMenu />} />,
  },
  {
    path: "supplier/list",
    element: <PrivateRoute element={<SupplierList />} />,
  },
  {
    path: "supplier/order/list",
    element: <PrivateRoute element={<SupplierOrderList />} />,
  },

  // 文章
  {
    path: "article/category",
    element: <PrivateRoute element={<ArticleCategory />} />,
  },
  { path: "article/list", element: <PrivateRoute element={<ArticleList />} /> },
  {
    path: "article/add",
    element: <PrivateRoute element={<ArticleDetail />} />,
  },
  {
    path: "article/edit/:id",
    element: <PrivateRoute element={<ArticleDetail />} />,
  },

  // 商学院
  {
    path: "businessSchool/category",
    element: <PrivateRoute element={<BusinessSchoolCategory />} />,
  },
  {
    path: "businessSchool/list",
    element: <PrivateRoute element={<BusinessSchoolList />} />,
  },
  {
    path: "businessSchool/add",
    element: <PrivateRoute element={<BusinessSchoolDetail />} />,
  },
  {
    path: "businessSchool/edit/:id",
    element: <PrivateRoute element={<BusinessSchoolDetail />} />,
  },
  {
    path: "businessSchool/merchantCodes",
    element: <PrivateRoute element={<MerchantCodeList />} />,
  },

  // 分销
  { path: "agent/config", element: <PrivateRoute element={<AgentConfig />} /> },
  { path: "agent/list", element: <PrivateRoute element={<AgentList />} /> },
  {
    path: "agent/detail/:uid",
    element: <PrivateRoute element={<AgentDetail />} />,
  },
  { path: "agent/menu", element: <PrivateRoute element={<AgentMenu />} /> },
  {
    path: "agent/balance/list",
    element: <PrivateRoute element={<AgentBalanceRecord />} />,
  },

  {
    path: "marketing/coupon/list",
    element: <PrivateRoute element={<CouponList />} />,
  },
  {
    path: "marketing/coupon/add",
    element: <PrivateRoute element={<CouponDetail />} />,
  },
  {
    path: "marketing/coupon/edit/:id",
    element: <PrivateRoute element={<CouponDetail />} />,
  },
  {
    path: "marketing/coupon/record",
    element: <PrivateRoute element={<CouponRecord />} />,
  },
  {
    path: "marketing/coupon/hexiao",
    element: <PrivateRoute element={<HexiaoList />} />,
  },

  // 权限
  { path: "access/roles", element: <PrivateRoute element={<SystemRole />} /> },
  { path: "access/menus", element: <PrivateRoute element={<SystemMenu />} /> },
  {
    path: "access/admins",
    element: <PrivateRoute element={<SystemAdmin />} />,
  },
  {
    path: "system/manage",
    element: <PrivateRoute element={<SystemmAnage />} />,
  },

  {
    path: "setting/agreement/list",
    element: <PrivateRoute element={<AgreementList />} />,
  },
  {
    path: "setting/notice/list",
    element: <PrivateRoute element={<NoticeList />} />,
  },

  // 资源
  { path: "resource/images", element: <PrivateRoute element={<Images />} /> },

  // 个人中心
  { path: "my", element: <PrivateRoute element={<MyInfo />} /> },

  // 开发维护
  {
    path: "dev/config",
    element: <PrivateRoute element={<SystemConfigList />} />,
  },

  // 商城装修
  { path: "diy/menu/list", element: <PrivateRoute element={<MenuList />} /> },
  {
    path: "diy/banner/list",
    element: <PrivateRoute element={<BannerList />} />,
  },
  {
    path: "diy/notice/list",
    element: <PrivateRoute element={<NoticeList />} />,
  },
  { path: "diy/list", element: <PrivateRoute element={<DiyList />} /> },
  { path: "diy/add", element: <PrivateRoute element={<DiyDetail />} /> },
  { path: "diy/edit/:id", element: <PrivateRoute element={<DiyDetail />} /> },

  // 客服
  { path: "kefu/config", element: <PrivateRoute element={<KefuConfig />} /> },
  { path: "kefu/chat", element: <PrivateRoute element={<KefuChat />} /> },

  // 数据统计
  {
    path: "stats/merchant",
    element: <PrivateRoute element={<MerchantRank />} />,
  },
  { path: "stats/area", element: <PrivateRoute element={<StatsArea />} /> },
  {
    path: "stats/rank/tiejun",
    element: <PrivateRoute element={<TiejunRank />} />,
  },
];

if (ROLE === "supplier") {
  routes = [
    {
      path: "",
      exact: true,
      element: <PrivateRoute element={<SupplierDashboardApp />} />,
    },

    // 商城
    {
      path: "product/list",
      element: <PrivateRoute element={<SupplierProductList />} />,
    },
    {
      path: "product/attr",
      element: <PrivateRoute element={<SupplierProductAttr />} />,
    },

    {
      path: "/order/list",
      element: <PrivateRoute element={<SupplierOrderList />} />,
    },
    {
      path: "/companyEvent/index",
      element: <PrivateRoute element={<CompanyEventIndex />} />,
    },
    {
      path: "/companyEvent/activity",
      element: <PrivateRoute element={<CompanyEventActivity />} />,
    },
    // 财务
    {
      path: "finance/transaction/list",
      element: <PrivateRoute element={<SupplierTransaction />} />,
    },
    {
      path: "finance/settlement/list",
      element: <PrivateRoute element={<SupplierSettlement />} />,
    },

    // 权限
    {
      path: "access/roles",
      element: <PrivateRoute element={<SupplierRole />} />,
    },
    {
      path: "access/admins",
      element: <PrivateRoute element={<SupplierAdmin />} />,
    },

    // 资源
    // 个人中心
    { path: "info", element: <PrivateRoute element={<SupplierInfo />} /> },
  ];
}

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: <DashboardLayout />,
      children: routes,
    },
    {
      path: "/login",
      element: <LogoOnlyLayout />,
      children: [
        { path: "", element: <Login /> },
        // { path: '404', element: <NotFound /> },
        // { path: '/', element: <PrivateRoute element={<Navigate to="/dashboard/app" replace />} /> },
        // { path: '*', element: <PrivateRoute element={<Navigate to="/dashboard/app" replace />} /> }
      ],
    },

    { path: "*", element: <Navigate to={"/"} replace /> },
  ]);
}
